var app = angular.module("leonardo");

var UnitForm = function($scope, $rootScope, UnitService, UnitTypeService, FormErrorsService, FilterService,
                        PropertyService) {
  $scope.mode = $scope.ngDialogData.mode;
  $scope.unit = $scope.ngDialogData.unit;
  $scope.property = $scope.ngDialogData.property ? PropertyService.get($scope.ngDialogData.property): null;
  $scope.filterService = FilterService;
  $scope.unitTypeService = UnitTypeService;

  $scope.expanded = false;

  $scope.account = $scope.unit ? $scope.unit.account : $scope.ngDialogData.account;

  $scope.buildingPattern = {
    pattern: new RegExp('^[a-zA-Z0-9-]+$'),
    text: 'Buildings can be alphanumeric and might even include a "-"'
  };

  $scope.expand = function() {
    $scope.expanded = !$scope.expanded;
  };

  $scope.getData = function() {
    return {
      client_instance: $scope.data.client_instance,
      account: $scope.data.account,
      unit_type: $scope.data.unit_type,
      property: $scope.data.property,
      number: $scope.data.number,
      building: $scope.data.building,
      sq_feet: $scope.data.sq_feet ? $scope.data.sq_feet : null,
      phase: $scope.data.phase
    };
  };

  $scope.submit = function() {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    var data = $scope.getData();
    if ($scope.mode === 'edit'){
      $scope.unit.patch(data).then(function(){
        $rootScope.$broadcast('unit:updated', true);
        $scope.closeThisDialog();
      });
    }
    else {
      UnitService.post(data).then(function(result) {
        UnitService.updateCollection(result);
        $rootScope.$broadcast('unit:created', true);
        $scope.closeThisDialog();
      });
    }
  };

  if ($scope.mode === 'edit'){
    $scope.data = angular.copy($scope.unit);
    $scope.data.unit_type = $scope.unit.unit_type.id;
  }
  else {
    $scope.data = {
      account: $scope.account
    };
  }

};

app.controller('UnitForm', ['$scope', '$rootScope', 'UnitService', 'UnitTypeService', 'FormErrorsService',
  'FilterService', 'PropertyService', UnitForm]);
